import { ApolloError, QueryResult, useQuery } from '@apollo/client';
import GET_GUESS_WHERE_ACTIVITY from '../../queries/activities/guess-where-query';
import { GuessWhereActivity as GuessWhere } from '@monorepo/shared/src/graph/schema-generated-types-student';
import { StoreTypename } from 'types';

const DEFAULT_BOOK_EDTION = 2022;

export type GuessWhereActivityState = {
  activity: any;
  error: ApolloError | undefined;
  isLoading: boolean;
};
export type GuessWhereActivityDispatch = undefined;
export type GuessWhereActivity = [GuessWhereActivityState, GuessWhereActivityDispatch];

export const GuessWhereActivity = (): { __typename: string } => ({
  __typename: StoreTypename.GUESS_WHERE_ACTIVITY,
});

const useGuessWhereActivityStore = (bookCode: string, edition?: number): GuessWhereActivity => {
  const { data, loading, error }: QueryResult<{ guessWhere: GuessWhere | undefined }> = useQuery(
    GET_GUESS_WHERE_ACTIVITY,
    {
      variables: { where: { book: { bookCode, edition: edition || DEFAULT_BOOK_EDTION } } },
    }
  );

  return [
    {
      activity: data?.guessWhere || null,
      error,
      isLoading: loading,
    },
    undefined,
  ];
};

export default useGuessWhereActivityStore;
